import React from "react";
import { ReactSVG } from "react-svg";
import CustomInput from "../../../../common/CustomInput";
import Button from "../../../../common/Button";

const ClinicalAlertInformationHeader = ({
  setIsActiveAlertPresent,
  allAlerts,
  setShowCreateSlider,
  isActiveAlertPresent,
  filterOptions,
  tableFilter,
  setTableFilter,
  alerts
}) => {
  return (
    <div className="flex justify-between">
      <div className="flex items-center">
        <div className="flex justify-center items-center pr-6">
          <h3>
            <input
              id="known-alert"
              name="known-alert"
              onClick={() => {
                setIsActiveAlertPresent(true);
                if (allAlerts.length === 0) {
                  setShowCreateSlider(true);
                }
              }}
              value={isActiveAlertPresent === true}
              checked={isActiveAlertPresent === true}
              type="radio"
              className="w-[45px] h-[45px] border-gray-100 cursor-pointer form-radio text-REELTeal focus:ring-transparent"
            />
          </h3>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex flex-col">
            <h3 className="text-xl font-semibold text-gray-800">
              {isActiveAlertPresent ? "Clinical Alerts" : "Add Clinical Alert"}
            </h3>
          </div>
        </div>
      </div>
      {isActiveAlertPresent === true && (
        <div className="flex justify-between">
          <CustomInput
            options={filterOptions}
            name="Filter"
            className="font-semibold mr-6 bg-white !py-[14px] rounded-[4px] !px-[16px] text-body-md !w-[200px] !h-full"
            type="dropdown"
            showOptionalLabel={false}
            value={tableFilter}
            onChange={(e) => setTableFilter(e.value)}
          />
          <Button
            className="flex whitespace-nowrap mr-4 !py-[14px] rounded-[4px] !px-[32px] text-body-md !w-[200px] !h-full"
            type="primary"
            text="Add Clinical Alert"
            onClick={() => {
              setShowCreateSlider(true);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ClinicalAlertInformationHeader;

